import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Persona } from 'src/app/models/persona';
import { PersonaService } from 'src/app/services/persona.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  formRestablecer: FormGroup;
  summited: Boolean;
  error: {code: number, message: string}= null;
  actuario:Persona;
  isEmail : boolean = true;

  @ViewChild('modal') modal;
  
  constructor(private service: PersonaService, 
    private router: Router,
    private formBuilder:FormBuilder) {}

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      usuario: ['', Validators.required],
      ingreso: ['', Validators.required]
    });

    this.formRestablecer = this.formBuilder.group({
      user: ['', Validators.required]
    });
}
get f() {
  return this.loginForm.controls;
}
 submitLogin(): void{
 
    this.service.logear(this.f.usuario.value, this.f.ingreso.value).subscribe(persona => {
      
 
      let fechaData = new Date(persona.fechaGeneraIngreso);
      
      let fechaActual = new Date();
          fechaData.setHours(0,0,0,0);
          fechaActual.setHours(0,0,0,0);
          if((persona.tipoIngreso == 0  && persona.estatus == 1 )||(!(persona.ingresoSeguro === 'SEGURA'))){
            
              this.router.navigate(['/cambioPasswordInicial', persona.rfc]);
                      
          } else if((persona.tipoIngreso == 1 && persona.estatus == 1) || ((persona.ingresoSeguro === 'SEGURA'))){
                      
            this.service.obtenToken(this.f.usuario.value, this.f.ingreso.value).subscribe(
              data => {
                console.log("Ingreso Permitido");
                this.router.navigate(['/cedulas', persona.rfc]);
                if(data.access_token){
                  localStorage.setItem("token", data.access_token);
                  this.router.navigate(['/cedulas', persona.rfc]);
                }
              });
            
          } else {
            swal.fire(
              'Error',
              'El Usuario Esta Blockeado, Contacta Al Encargado Del Sistema De La CNSF.',
              'error'
            )
          } 
    });
        
    this.summited = true;
   this.error = null;
    
  }

  restablecerPassword(){
    this.isEmail  = true;

    if(!this.esEmailValido(this.formRestablecer.controls['user'].value)){
      this.isEmail  = false;
      return
    }

    this.service.buscarUsuario(this.formRestablecer.controls['user'].value).subscribe(data => {

      if(data.success){

        if(data.estatusUsuario === ''){
          swal.fire(
            "Usted no cuenta aun con contraseña temporal o definitiva registrada, por favor espere a recibir correo con el enlace de descarga y contraseña temporal.",
            '',
            'error'
          )
          return;
        }
        //
        this.service.restablecer(this.formRestablecer.controls['user'].value).subscribe(data => {

          if(data.success){
            swal.fire(
              data.mensaje,
              '',
              'success'
            )
            this.modal.nativeElement.className ='modal hide'
          }else{
            swal.fire(
              data.mensaje,
              '',
              'error'
            )
          }
          
        });
        //
      }else{
        console.log(data.mensaje);
        let msj = data.mensaje === 'El usuario no existe' ?  data.mensaje : "Usted no cuenta aun con contraseña temporal o definitiva registrada, por favor espere a recibir correo con el enlace de descarga y contraseña temporal.";
        swal.fire(
          msj,
          '',
          'error'
        )
      }
    });
  }

  mostrarModal(){
    this.isEmail  = true;
    this.formRestablecer.controls['user'].setValue("");
    this.modal.nativeElement.className ='modal show';
  }

  cerrarModal(){
    this.modal.nativeElement.className ='modal hide';
  }

  esEmailValido(email: string):boolean {
    let mailValido = false;
      'use strict';

      var EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      if (email.match(EMAIL_REGEX)){
        mailValido = true;
      }
    return mailValido;
  }
  
}
